import { RouteObject } from 'react-router-dom';
import AppLayout from '@/components/feature/AppLayout';
import DashboardPage from '@/pages/dashboard/page';
import TransfersPage from '@/pages/transfers/page';
import ClientsPage from '@/pages/clients/page';
import InventoryPage from '@/pages/inventory/page';
import SalesPage from '@/pages/sales/page';
import ReportsPage from '@/pages/reports/page';
import SettingsPage from '@/pages/settings/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout><DashboardPage /></AppLayout>,
  },
  {
    path: '/transfers',
    element: <AppLayout><TransfersPage /></AppLayout>,
  },
  {
    path: '/clients',
    element: <AppLayout><ClientsPage /></AppLayout>,
  },
  {
    path: '/inventory',
    element: <AppLayout><InventoryPage /></AppLayout>,
  },
  {
    path: '/sales',
    element: <AppLayout><SalesPage /></AppLayout>,
  },
  {
    path: '/reports',
    element: <AppLayout><ReportsPage /></AppLayout>,
  },
  {
    path: '/settings',
    element: <AppLayout><SettingsPage /></AppLayout>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
